import { Action, createReducer, on } from '@ngrx/store';
import { fetchUsersList, fetchUsersListSuccess, fetchUsersListFailure } from './users.action';


export interface UsersState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: UsersState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const UsersReducer = createReducer(
  initialState,
  on(fetchUsersList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchUsersListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchUsersListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: UsersState | undefined, action: Action) {
  return UsersReducer(state, action);
}
